import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getOfferingTypesData = (state, setState) => {
  const api = initApi(API_NAMES.OMR, state, setState);
  const url = '/OfferingType';

  return api?.executeArray ? api.executeArray(url, 'GET') : null;
};

const INITIAL_OFFERING_TYPES_STATE = {
  ...BASIC_INITIAL_STATE
};

const OfferingTypesData = {
  INITIAL_OFFERING_TYPES_STATE,

  getOfferingTypesData
};

export default OfferingTypesData;